import React from 'react';
export function SystemImage() {
  return <section className="bg-warm-mid py-16 md:py-20 px-4" data-id="element-292">
      <div className="max-w-3xl mx-auto text-center" data-id="element-293">
        {/* Heading */}
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-hero mb-8 leading-tight" data-id="element-294">
          Not random tips. A complete{' '}
          <span className="italic text-soft-gold" data-id="element-295">
            beginner-friendly system.
          </span>
        </h2>

        {/* Premium Product Composition */}
        <div className="mb-8 rounded-2xl overflow-hidden shadow-xl max-w-2xl mx-auto" data-id="element-296">
          <div className="relative w-full overflow-hidden rounded-2xl" style={{
          background: 'linear-gradient(135deg, #F5EDE3 0%, #EDE4D8 30%, #E8DDD0 60%, #F0E8DE 100%)',
          aspectRatio: '16 / 9'
        }} data-id="element-297">
            {/* Subtle warm light overlay */}
            <div className="absolute inset-0 pointer-events-none" style={{
            background: 'radial-gradient(ellipse at 30% 40%, rgba(255,248,235,0.5) 0%, transparent 70%)'
          }} data-id="element-298" />

            {/* Book Cover — Left Side, Primary Focal Point */}
            <div className="absolute" style={{
            left: '4%',
            top: '50%',
            transform: 'translateY(-50%) rotate(-1deg)',
            width: '42%',
            zIndex: 10,
            filter: 'drop-shadow(0 8px 24px rgba(42,29,16,0.3)) drop-shadow(0 2px 8px rgba(42,29,16,0.15))'
          }} data-id="element-299">
              <img src="https://cdn.magicpatterns.com/uploads/x1seQq9xscNbKD39VCMpZB/Captura_de_Pantalla_2026-03-20_a_la(s)_8.40.00_p._m..png" alt="The Pawfect Shot MegaPack Book 1 — Phone Dog Photography cover" className="w-full h-auto rounded-sm" style={{
              boxShadow: '4px 4px 20px rgba(42,29,16,0.25), -1px -1px 4px rgba(255,255,255,0.1)'
            }} data-id="element-300" />
            </div>

            {/* Interior Page 2 — Back Page (partially visible) */}
            <div className="absolute" style={{
            right: '6%',
            top: '50%',
            transform: 'translateY(-50%) rotate(2deg)',
            width: '36%',
            zIndex: 5,
            filter: 'drop-shadow(0 6px 18px rgba(42,29,16,0.2))'
          }} data-id="element-301">
              <img src="https://cdn.magicpatterns.com/uploads/7LvV9BNpu3qciKbMLo5ZM7/Captura_de_Pantalla_2026-03-20_a_la(s)_8.39.27_p._m..png" alt="Interior page preview — Know When Your Dog Needs a Break" className="w-full h-auto rounded-sm" style={{
              boxShadow: '3px 3px 16px rgba(42,29,16,0.2)'
            }} data-id="element-302" />
            </div>

            {/* Interior Page 1 — Front Page (more visible, overlaps back page) */}
            <div className="absolute" style={{
            right: '12%',
            top: '50%',
            transform: 'translateY(-48%) rotate(-0.5deg)',
            width: '36%',
            zIndex: 8,
            filter: 'drop-shadow(0 8px 22px rgba(42,29,16,0.25))'
          }} data-id="element-303">
              <img src="https://cdn.magicpatterns.com/uploads/obg2Uyhd4ja7oZ4A2Vmqo9/Captura_de_Pantalla_2026-03-20_a_la(s)_8.38.40_p._m..png" alt="Interior page preview — Prep Steps That Make a Real Difference" className="w-full h-auto rounded-sm" style={{
              boxShadow: '4px 4px 18px rgba(42,29,16,0.22), -1px -1px 3px rgba(255,255,255,0.08)'
            }} data-id="element-304" />
            </div>
          </div>
        </div>

        {/* Text below */}
        <p className="font-sans text-lg md:text-xl text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-305">
          Everything is structured to help you improve faster, feel less
          overwhelmed, and{' '}
          <span className="font-semibold text-warm-hero" data-id="element-306">
            stop guessing every time you open your camera.
          </span>
        </p>
      </div>
    </section>;
}